export { default as TeacherEdit } from './TeacherEdit';

